import React from 'react'
import PropTypes from 'prop-types'
import Text from '../../ui/Text'

const PILL_BASE = 'tw:rounded! tw:px-2 tw:py-0.5 tw:text-xs tw:font-medium '
  + 'tw:bg-gray-200 tw:text-gray-800'
const SINGLE_PILL_CLASS = `tw:inline-block tw:max-w-full tw:align-middle ${PILL_BASE}`
const MULTI_PILL_CLASS = `tw:min-w-0 ${PILL_BASE}`
const MULTI_BADGE_CLASS = `tw:flex-shrink-0 ${PILL_BASE}`
const EMPTY_PILL_CLASS = `tw:inline-block tw:align-middle ${PILL_BASE}`

const EMPTY_USERS = []

const AttributionCell = ({ users = EMPTY_USERS }) => {
  if (!users || users.length === 0)
    return <span className={EMPTY_PILL_CLASS}>--</span>
  if (users.length === 1) {
    return (
      <span className={SINGLE_PILL_CLASS}>
        <Text lines={1}>{users[0].full_name}</Text>
      </span>
    )
  }
  return (
    <div className="tw:flex tw:items-center tw:gap-1 tw:min-w-0">
      <span className={MULTI_PILL_CLASS}>
        <Text lines={1}>{users[0].full_name}</Text>
      </span>
      <span className={MULTI_BADGE_CLASS}>{`+${users.length - 1}`}</span>
    </div>
  )
}

AttributionCell.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  }))
}

AttributionCell.defaultProps = {
  users: []
}

export default AttributionCell
